// Added by Sejune Oh on 2020-03-20
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 *  [1] Interface
 *  [2] Type
 *  [3] Enum
 *  [4] Constants
 */

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// # [1] Interface
export interface Task {
  id?: string
  rule_id?: string
  system_token?: string
  study_instance_uid?: string
  series_instance_uids?: string
  username?: string
  user_email?: string
  user_display_name?: string
  type?: string
  status?: TaskStatus
  proc_name?: string
  proc_version?: string
  proc_params?: string
  proc_exit_code?: number
  proc_executing_time?: number
  proc_started_at?: string
  proc_completed_at?: string
  assgined_node_key?: string
  created_at?: string
  updated_at?: string
  rule_name?: string
  [key: string]: string | number | undefined
}

export interface TaskMonitoringElement {
  id: string
  proc_name: string
  rule_name: string
  status: string
  username: string
  user_display_name: string
  type: string
  created_at: string
  proc_started_at: string
  patient_id: string
  patient_name: string
  study_description: string
  study_date_time: string
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// # [2] Type
export type TaskStatus = 'RUNNING' | 'CANCELED' | 'WAITING' | 'RETRYING' | 'INVOKING' | 'DONE' | 'FAILED'
export type TaskExitCode = '0' | '1' | '10' | '11' | '12' | '100' | '200' | '300' | '400'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// # [3] Enum
export enum TaskStatusEnum {
  Running = 'RUNNING',
  Canceled = 'CANCELED',
  Waiting = 'WAITING',
  Retrying = 'RETRYING',
  Invoking = 'INVOKING',
  Done = 'DONE',
  Failed = 'FAILED'
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// # [4] Constants
export const TASK_EXIT_CODE: Record<TaskExitCode, string> = {
  '0': 'Done',
  '1': 'Process exception',
  '10': 'Invalid process name',
  '11': 'Cannot start process',
  '12': 'Invalid task configuration',
  '100': 'Parameter error',
  '200': 'Server error',
  '300': 'License error',
  '400': 'General error',
}
